import React, { useState } from 'react';
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  Observable
} from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { RestLink } from 'apollo-link-rest';
import { setContext } from 'apollo-link-context';
/* import gql from 'graphql-tag'; */
import { ApolloProvider } from '@apollo/react-hooks';
import { onError } from 'apollo-link-error';
import { message } from 'antd';

import { /* checkBaconLicenses, */ logout, refreshToken } from './shared/utils/auth';
import { UserProvider } from './context/UserContext';
import Routes from './Routes';
import './styles/antdBacon.css';
import 'dotenv/config';

const accessToken = localStorage.getItem('auth.accessToken');
const restLink = new RestLink({
  uri: process.env.REACT_APP_SERVER_HOST,
});

// Error handling
const linkErrors = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ errorMessage, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${errorMessage}, Location: ${locations}, Path: ${path}`
        )
      );
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      if (networkError.statusCode === 401) {
        if (
          networkError.result &&
          networkError.result.code === 'user_not_found'
        ) {
          logout();
          // eslint-disable-next-line no-restricted-globals
          location.href = '/login';
          alert('There was an error. Please contact an administrator');
        } else if (operation.operationName === 'refreshToken') {
          localStorage.removeItem('auth.refreshToken');
          localStorage.removeItem('auth.accessToken');
          // eslint-disable-next-line no-restricted-globals
          location.href = '/login';
        } else {
          // Apollo expects an Observable as result of an onError function
          // eslint-disable-next-line no-use-before-define
          localStorage.removeItem('auth.accessToken');
          return new Observable(observer => {
            const rt = localStorage.getItem('auth.refreshToken');
            // eslint-disable-next-line no-use-before-define
            refreshToken(client, rt)
              .then(res => {
                operation.setContext(({ headers = {} }) => ({
                  headers: {
                    // Re-add old headers
                    ...headers,
                    // Switch out old access token for new one
                    Authorization: `Bearer ${res}` || null,
                  },
                }));
              })
              .then(() => {
                const subscriber = {
                  next: observer.next.bind(observer),
                  error: observer.error.bind(observer),
                  complete: observer.complete.bind(observer),
                };
                // Retry last failed request
                forward(operation).subscribe(subscriber);
              })
              .catch(error => {
                // No refresh or client token available, we force user to login
                observer.error(error);
              });
          });
        }
      } else if (networkError.statusCode === 403) {
        // eslint-disable-next-line no-use-before-define
        message.error({
          content: 'You do not have permissions to enter this page',
          key: '403-Error',
        });
      } else if (networkError.statusCode === 404) {
        // eslint-disable-next-line no-restricted-globals
        location.href = '/notfound';
      }
    }
  }
);


const queriesWithOctetStreamContentType = [];
const queriesWithMultiPartContentType = [];

const authLink = setContext((operation, data) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('auth.accessToken');
  // return the headers to the context
  const newHeader = { ...data.headers };
  if (token) {
    newHeader.Authorization = `Bearer ${token}`;
  }
  if (queriesWithOctetStreamContentType.includes(operation.operationName)) {
    newHeader['Content-Type'] = 'application/octet-stream';
  } else if (
    queriesWithMultiPartContentType.includes(operation.operationName)
  ) {
    newHeader['Content-Type'] = 'multipart/form-data';
  } else {
    newHeader['Content-Type'] = 'application/json';
  }

  return {
    headers: newHeader,
  };
});

// make requests network-only
const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
};

// new

// setup your client
const client = new ApolloClient({
  link: ApolloLink.from([authLink, linkErrors , restLink]),
  cache: new InMemoryCache(),
  defaultOptions,
});

// new
/*const query = gql`
  query getBackendVersion {
    getBackendVersionResponse(query: {})
      @rest(
        type: "getBackendVersion"
        path: "/auth/web_setup/backend_version/"
        method: "GET"
      ) {
      backend_version
    }
  }
`;

client.query({ query }).then( response => {
  console.log(response.data.getBackendVersionResponse);
} );*/

function App () {

  const userId = localStorage.getItem('user.id');
  const userIsAdmin = localStorage.getItem('user.is_admin') === 'true';
  const eulaAccepted = localStorage.getItem('user.eulaAccepted') === 'true';
  const permissions = localStorage.getItem('user.permissions')
    ? JSON.parse(localStorage.getItem('user.permissions'))
    : null;
  const organization = localStorage.getItem('user.organization');
  const passwordUpdateRequired = localStorage.getItem('user.passwordUpdateRequired') === 'true';
  const username = localStorage.getItem('user.username');

  // Logged-in user
  const userData = {
    accessToken,
    loggedIn: accessToken !== null,
    /* role: userRole, */
    permissions,
    userId,
    eulaAccepted,
    userIsAdmin,
    organization,
    passwordUpdateRequired,
    username,
  };
  const [user, setUser] = useState(userData);

  // Instead of setting the value directly on the Provider like:
  // <UserProvider value={{ user, setUser }}>
  // Create an object with the data and pass it to the Provider.
  // More info: https://reactjs.org/docs/context.html#caveats
  const providerValue = { user, setUser };

  return (
    <UserProvider value={providerValue}>
      <Router>
        <ApolloProvider client={client}>
          <div className="App">
            <Routes />
          </div>
        </ApolloProvider>
      </Router>
    </UserProvider>
  );
}

export default App;
